import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';

import messages from './messages';

function Suggestion({ suggestion }) {
  return (
    <div>
      <span className="typeahead-value">{suggestion.id}</span>
      <span className="typeahead-in"><Trans id={messages.in} /></span>
      <span className="typeahead-type">
        {suggestion.type === 'case' ?
          <Trans id={messages.cases} /> :
          <Trans id={messages.assets} />
        }
      </span>
    </div>
  );
}

Suggestion.propTypes = {
  suggestion: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};
export default Suggestion;



// WEBPACK FOOTER //
// ./elements/Autosuggest/Suggestion.js